import React from "react";
import Tooltip from "@mui/material/Tooltip";
import Skeleton from "@mui/material/Skeleton";

const RuleTableBody = ({
  tableData = [],
  isSearching = false,
  columnSearch = {},
  highlightMatch = (t) => t,
}) => {
  return (
    <tbody>
      {isSearching ? (
        [...Array(10)].map((_, i) => (
          <tr key={i} style={{ height: "35px" }}>
            {[
              "160px",
              "130px",
              "200px",
              "130px",
              "100px",
              "80px",
              "100px",
              "140px",
              "150px",
              "130px",
              "150px",
              "70px",
            ].map((width, j) => (
              <td key={j} style={{ padding: "10px", height: "35px" }}>
                <Skeleton variant="text" height={20} style={{ width }} />
              </td>
            ))}
          </tr>
        ))
      ) : tableData.length > 0 ? (
        tableData.map((rule, index) => (
          <tr
            key={index}
            style={{ backgroundColor: index % 2 === 0 ? "white" : "#eee" }}
            className="w-full"
          >
            <td className="text-left align-middle w-[160px]" style={{ fontSize: "10px" }}>
              <Tooltip
                title={rule.ruleId || ""}
                slotProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "#ece5e5ff",
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "Poppins",
                      padding: "8px 10px",
                      borderRadius: "6px",
                    },
                  },
                }}
              >
                <span className="block font-poppins text-[10px] truncate w-[160px]">
                  {highlightMatch(
                    (() => {
                      const text = rule.ruleId || "";
                      const words = text.trim().split(/\s+/).filter(Boolean);
                      return words.length > 15 ? words.slice(0, 15).join(" ") + "..." : text;
                    })(),
                    columnSearch.ruleId || columnSearch.allsearch
                  )}
                </span>
              </Tooltip>
            </td>

            <td className="text-left align-middle" style={{ width: "180px", fontSize: "10px" }}>
              <Tooltip
                title={rule.ruleName?.includes("|") ? rule.ruleName.split("|")[1]?.trim() : rule.ruleName || ""}
                slotProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "#ece5e5ff",
                      color: "black",
                      fontSize: "12px",
                      fontFamily: "Poppins",
                      padding: "8px 10px",
                      borderRadius: "6px",
                    },
                  },
                }}
              >
                <span className="block font-poppins w-[130px] text-[10px] truncate">
                  {highlightMatch(
                    (() => {
                      const text = rule.ruleName?.includes("|")
                        ? rule.ruleName.split("|")[1]?.trim()
                        : rule.ruleName || "";
                      const words = text.split(/\s+/);
                      return words.length > 5 ? words.slice(0, 5).join(" ") + "..." : text;
                    })(),
                    columnSearch.ruleName || columnSearch.allsearch
                  )}
                </span>
              </Tooltip>
            </td>

            <td className="text-left align-middle w-[200px]" style={{ fontSize: "10px" }}>
              <Tooltip
                title={rule.description || ""}
                slotProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "#ece5e5ff",
                      color: "black",
                      fontSize: "12px",
                      fontFamily: "Poppins",
                      padding: "8px 10px",
                      borderRadius: "6px",
                      maxWidth: "400px",
                      whiteSpace: "pre-wrap",
                    },
                  },
                }}
              >
                <span className="block font-poppins text-[10px] truncate w-[200px]">
                  {highlightMatch(
                    (() => {
                      const text = rule.description || "";
                      const words = text.split(/\s+/);
                      return words.length > 5 ? words.slice(0, 5).join(" ") + "..." : text;
                    })(),
                    columnSearch.description || columnSearch.allsearch
                  )}
                </span>
              </Tooltip>
            </td>

            <td className="text-left align-middle" style={{ fontSize: "10px" }}>
              <div className="overflow-x-auto  w-[130px] whitespace-nowrap">
                {highlightMatch(
                  (rule.dqDimension || "").charAt(0).toUpperCase() + (rule.dqDimension || "").slice(1).toLowerCase(),
                  columnSearch.dqDimension || columnSearch.allsearch
                )}
              </div>
            </td>

            <td className="text-left align-middle w-[100px]" style={{ fontSize: "10px" }}>
              <Tooltip
                title={Array.isArray(rule.keywords) && rule.keywords.length > 0 ? rule.keywords.map((k) => k.toLowerCase()).join(", ") : "N/A"}
                slotProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "#ece5e5ff",
                      color: "black",
                      fontSize: "12px",
                      fontFamily: "Poppins",
                      padding: "8px 10px",
                      borderRadius: "6px",
                      maxWidth: "400px",
                      whiteSpace: "pre-wrap",
                    },
                  },
                }}
              >
                <span className="block font-poppins text-[10px] truncate w-[130px]">
                  {highlightMatch(
                    (() => {
                      const text = Array.isArray(rule.keywords) && rule.keywords.length > 0 ? rule.keywords.map((k) => k.toLowerCase()).join(", ") : "N/A";
                      const words = text.split(/\s+/);
                      return words.length > 5 ? words.slice(0, 10).join(" ") + "..." : text;
                    })(),
                    columnSearch.keywords || columnSearch.allsearch
                  )}
                </span>
              </Tooltip>
            </td>

            <td className="text-left align-middle" style={{ fontSize: "10px" }}>
              <div className="overflow-x-auto w-[80px] whitespace-nowrap ">
                {highlightMatch(
                  rule.checkType ? rule.checkType.charAt(0).toUpperCase() + rule.checkType.slice(1) : "",
                  columnSearch.checkType || columnSearch.allsearch
                )}
              </div>
            </td>

            <td className="text-left align-middle" style={{ fontSize: "10px" }}>
              <div className="overflow-x-auto whitespace-nowrap w-[100px]">
                {highlightMatch(
                  rule.rulePhase?.includes("|") ? rule.rulePhase.split("|")[1]?.trim() : rule.rulePhase || "",
                  columnSearch.rulePhase || columnSearch.allsearch
                )}
              </div>
            </td>

            <td className="text-left align-middle w-[140px]" style={{ fontSize: "10px" }}>
              <div className="overflow-x-auto whitespace-nowrap w-[100px]">
                {highlightMatch(rule.category || "", columnSearch.category || columnSearch.allsearch)}
              </div>
            </td>

            {/* <td className="text-left align-middle w-[150px]" style={{ fontSize: "10px" }}>
              <div className="overflow-x-auto  whitespace-nowrap w-[140px]" style={{ fontSize: "10px" }}>
                {highlightMatch(rule.threshold?.toString() || "", columnSearch.threshold || columnSearch.allsearch)}
              </div>

              <div className="w-full bg-gray-200 rounded-full h-2 mt-1">
                <div
                  className="h-2 rounded-full transition-all duration-300"
                  style={{
                    width: `${parseFloat(rule.threshold) || 0}%`,
                    backgroundColor: parseFloat(rule.threshold) > 95 ? "#009F52" : parseFloat(rule.threshold) > 90 ? "#FFC100" : "#FB0301",
                  }}
                ></div>
              </div>
            </td> */}
        <td
  className="text-left align-middle w-[150px]"
  style={{ fontSize: "10px" }}
>
  <div
    className="overflow-x-auto whitespace-nowrap w-[140px]"
    style={{ fontSize: "10px" }}
  >
    {highlightMatch(
      rule.threshold?.toString() ?? "0",
      columnSearch.threshold || columnSearch.allsearch
    )}
  </div>

  {Number((rule.threshold ?? "0").toString().replace("%", "")) > 0 && (
    <div className="w-full bg-gray-200 rounded-full h-2 mt-1">
      <div
        className="h-2 rounded-full transition-all duration-300"
        style={{
          width: `${Number((rule.threshold ?? "0").toString().replace("%", ""))}%`,
          backgroundColor:
            Number((rule.threshold ?? "0").toString().replace("%", "")) > 95
              ? "#009F52"
              : Number((rule.threshold ?? "0").toString().replace("%", "")) > 90
              ? "#FFC100"
              : "#FB0301",
        }}
      ></div>
    </div>
  )}
</td>



            <td className="text-left align-middle max-w-[250px]" style={{ fontSize: "10px" }}>
              <Tooltip
                title={rule.remediationAction || ""}
                slotProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "#ece5e5ff",
                      color: "black",
                      fontSize: "12px",
                      fontFamily: "Poppins",
                      padding: "8px 10px",
                      borderRadius: "6px",
                      maxWidth: "400px",
                      whiteSpace: "pre-wrap",
                    },
                  },
                }}
              >
                <span className="block font-poppins text-[10px]  truncate w-[130px]" style={{ fontSize: "10px" }}>
                  {(() => {
                    const text = rule.remediationAction || "";
                    const truncated = text.split(/\s+/).length > 12 ? text.split(/\s+/).slice(0, 12).join(" ") + "..." : text;
                    return highlightMatch(truncated, columnSearch.remediationAction || columnSearch.allsearch);
                  })()}
                </span>
              </Tooltip>
            </td>

            <td className="text-left align-middle" style={{ fontSize: "10px" }}>
              <div className="w-[160px]">{highlightMatch(rule.owner || "", columnSearch.owner || columnSearch.allsearch)}</div>
            </td>

            <td className="text-left align-middle w-[70px]" style={{ fontSize: "10px" }}>
              <div className="overflow-x-auto  whitespace-nowrap w-[100px]" style={{ fontSize: "10px" }}>
                {rule.status}
              </div>
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={12} style={{ textAlign: "center", padding: "1rem" }}>
            No records found
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default RuleTableBody;
